module.exports = __webpack_public_path__ + "static/media/TYP.76705618.png";